import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import { fixedWidthCustomStyle, REGEX} from "constants/CommonConstants";
import { validityTypeOptions } from "components/constant";

function AddDocumentModal({
  isOpen,
  toggle,
  title,
  label,
  onSave,
  isValidityModal = false,
}) {
  const [value, setValue] = useState("");
  const [errors, setErrors] = useState({
    value: "",
    durationType: "",
    durationValue: "",
  });

  const [validityData, setValidityData] = useState({
    durationType: "",
    durationValue: "",
  });

  const getValidationError = (field, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    switch (field) {
      case "durationType":
        return !trimmedValue ? "Please select duration type" : "";

      case "durationValue":
        if (!trimmedValue) {
          return "Please enter duration value";
        }

        if (!REGEX.OTP_STRING_REGEX.test(trimmedValue)) {
          return "Enter a valid number";
        }

        return "";

      case "value":
        return !trimmedValue ? `Please enter ${label.toLowerCase()}` : "";

      default:
        return "";
    }
  };

  const handleOnBlur = (field, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    setErrors((prev) => ({
      ...prev,
      [field]: getValidationError(field, trimmedValue),
    }));

    if (field === "durationValue") {
      setValidityData((prev) => ({
        ...prev,
        durationValue: trimmedValue,
      }));
    } else if (field === "value") {
      setValue(trimmedValue);
    }
  };

  const handleDurationValueChange = (value) => {
    if (!REGEX.ONLY_DIGITS_REGEX.test(value)) {
      return;
    }

    setValidityData((prev) => ({
      ...prev,
      durationValue: value,
    }));

    setErrors((prev) => ({
      ...prev,
      durationValue: "",
    }));
  };

  const handleSave = () => {
    const newErrors = {
      value: "",
      durationType: "",
      durationValue: "",
    };

    if (isValidityModal) {
      newErrors.durationType = getValidationError(
        "durationType",
        validityData.durationType,
      );

      newErrors.durationValue = getValidationError(
        "durationValue",
        validityData.durationValue,
      );

      if (newErrors.durationType || newErrors.durationValue) {
        setErrors(newErrors);
        return;
      }

      onSave({
        ...validityData,
        durationValue: validityData.durationValue.trim(),
      });

      setValidityData({
        durationType: "",
        durationValue: "",
      });
    } else {
      newErrors.value = getValidationError("value", value);

      if (newErrors.value) {
        setErrors(newErrors);
        return;
      }

      onSave(value.trim());
      setValue("");
    }

    setErrors({
      value: "",
      durationType: "",
      durationValue: "",
    });

    toggle();
  };

  const handleCancel = () => {
    setValue("");

    setValidityData({
      durationType: "",
      durationValue: "",
    });

    setErrors({
      value: "",
      durationType: "",
      durationValue: "",
    });

    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleCancel}
      centered
      className="validity-modal"
    >
      <ModalHeader toggle={handleCancel}>{title}</ModalHeader>

      <ModalBody>
        {isValidityModal ? (
          <>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Duration Type</Label>
                  <span className="text-danger"> *</span>
                  <Select
                    options={validityTypeOptions}
                    styles={fixedWidthCustomStyle()}
                    placeholder="Select duration type"
                    classNamePrefix="react-select"
                    className={
                      errors.durationType ? "add-document-invalid" : ""
                    }
                    value={validityTypeOptions.find(
                      (item) => item.value === validityData.durationType,
                    )}
                    onChange={(selected) => {
                      setValidityData((prev) => ({
                        ...prev,
                        durationType: selected.value,
                      }));

                      setErrors((prev) => ({
                        ...prev,
                        durationType: "",
                      }));
                    }}
                    onBlur={() =>
                      setErrors((prev) => ({
                        ...prev,
                        durationType: getValidationError(
                          "durationType",
                          validityData.durationType,
                        ),
                      }))
                    }
                  />

                  {errors.durationType && (
                    <div className="invalid-feedback d-block">
                      {errors.durationType}
                    </div>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label>Duration Value</Label>
                  <span className="text-danger"> *</span>
                  <Input
                    type="tel"
                    inputMode="numeric"
                    className={`validity-unit-input ${
                      errors.durationValue ? "is-invalid" : ""
                    }`}
                    placeholder="Enter duration value"
                    maxLength={3}
                    value={validityData.durationValue}
                    onChange={(e) => handleDurationValueChange(e.target.value)}
                    onBlur={(e) =>
                      handleOnBlur("durationValue", e.target.value)
                    }
                  />

                  {errors.durationValue && (
                    <div className="invalid-feedback d-block">
                      {errors.durationValue}
                    </div>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </>
        ) : (
          <FormGroup>
            <Label>{label}</Label>
            <span className="text-danger"> *</span>
            <Input
              placeholder={`Enter ${label.toLowerCase()}`}
              value={value}
              maxLength={100}
              className={errors.value ? "is-invalid" : ""}
              onChange={(e) => {
                setValue(e.target.value);

                setErrors((prev) => ({
                  ...prev,
                  value: "",
                }));
              }}
              onBlur={(e) => handleOnBlur("value", e.target.value)}
            />

            {errors.value && (
              <div className="invalid-feedback d-block">{errors.value}</div>
            )}
          </FormGroup>
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={handleCancel}
          className="mr-2 save-btn-sm"
        >
          Cancel
        </Button>
        <Button className="btn-deep-blue save-btn-sm" onClick={handleSave}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddDocumentModal;
